import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const getCompanySsoInfo = createSelector(getCompany, ({ sso }) => sso);
